import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import QRCode        from 'react-qr-code';


import MainAction        from './actions/main-action';
import EntryUrl          from './actions/entry-url';
import ReClientCheck     from './actions/re-client-check';
import ReEntry           from './actions/re-entry';
import DraftCheck        from './actions/draft-check';
import DraftCheckRemove  from './actions/draft-check-remove';
import DraftAdminEdit    from './actions/draft-admin-edit';
import DraftManualCreate from './actions/draft-manual-create';
import DeleteAction      from './actions/delete-action';
import ExLoginUrl        from './actions/exlogin-url';
import SetInsightAccess  from './actions/set-insight-access';
import NgAction          from './actions/ng-action';

// -------------------------------------------------------

const Tooltip = ({children}) => children || null;
const OverlayTrigger = ({children}) => children || null;

class InfluencerActions extends React.Component {
  render() {
    let base = this.props.base;
    let detail = this.props.detail;
    if( detail.workflow_status == undefined ) detail.workflow_status = {};
    
    let actions = [
      { name: 'クライアントに確認依頼',     html: <MainAction mode="client_check"  />,  icon: 'done' },
      { name: '再度クライアントに確認依頼', html: <ReClientCheck  />,  icon: 'done' },
      { name: 'インフルエンサーに案件依頼', html: <MainAction mode="assign_action" />,  icon: 'send' },
      { name: 'エントリー用のURLを発行',    html: <EntryUrl />, icon: 'link' },
      { name: '再エントリーの状態に変更',   html: <ReEntry />,  icon: 'undo' },
      { name: '下書き作成を依頼',           html: <MainAction mode="draft_action" />,  icon: 'draw' },
      { name: '下書きを代理で作成',         html: <DraftManualCreate />,  icon: 'edit_location_alt' },
      { name: '下書き確認',                 html: <DraftCheck />,  icon: 'check' },
      { name: '下書き確認済みを取り消す',   html: <DraftCheckRemove />,  icon: 'check' },
      { name: '管理者権限で下書きを編集',   html: <DraftAdminEdit />,  icon: 'drive_file_rename_outline' },
      { name: 'ワークフローから除外',       html: <DeleteAction />,  icon: 'delete' },
      { name: 'エントリー代行用のURL発行',  html: <ExLoginUrl />,  icon: 'key' },
      { name: 'インサイト提出を可能にする', html: <SetInsightAccess />,  icon: 'how_to_reg' },
      { name: 'ステータスをNGに変更',       html: <NgAction />,  icon: 'close' },
    ];
    
    return (
      <div className="project-influencer-contents-actions">
        
        <h6>ACTIONS</h6>
        <ul className="actions-menu">
          { actions.map((d, key) => {
            let button = <p>{(key + 1)}. <i className="material-icons">{d.icon}</i>{d.name}</p>;
            
            return React.cloneElement(d.html, { key: key, base: base, detail: detail, item: d, button: button, close_ev: this.props.close_ev.bind(this) });
          })}
        </ul>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerActions;